// extracted by mini-css-extract-plugin
export var alignCenter = "_bs-d";
export var bannerShown = "_bs-6";
export var buttonContent = "_bs-0";
export var cardList = "_bs-1";
export var centerContent = "_bs-2";
export var chevron = "_bs-3";
export var closePanelButton = "_bs-k";
export var conversationContextContainer = "_bs-l";
export var conversationDetailContainer = "_bs-4";
export var detailWrapper = "_bs-7";
export var dropdownButton = "_bs-e";
export var dropdownTitle = "_bs-9";
export var fullHeight = "_bs-5";
export var hidden = "_bs-a";
export var icon = "_bs-b";
export var mergeSuggestionWrapper = "_bs-m";
export var panel = "_bs-i";
export var portalButtonsWrapper = "_bs-c";
export var right = "_bs-j";
export var tableSummaryContainer = "_bs-8";
export var tableSummaryHeader = "_bs-g";
export var threeDotsButton = "_bs-f";
export var wide = "_bs-h";